import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import Modal from 'react-bootstrap/Modal';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import undoIcon from '../../../assets/images/text-editor/undo.svg';
import redoIcon from '../../../assets/images/text-editor/redo.svg';
import boldIcon from '../../../assets/images/text-editor/bold.svg';
import italicIcon from '../../../assets/images/text-editor/italic.svg';
import leftIcon from '../../../assets/images/text-editor/left.svg';
import centerIcon from '../../../assets/images/text-editor/justify.svg';
import unorderedIcon from '../../../assets/images/text-editor/unordered.svg';
import orderedIcon from '../../../assets/images/text-editor/ordered.svg';
import linkIcon from '../../../assets/images/text-editor/link.svg';
import checkmarkIcon from '../../../assets/images/view-meeting/checkmark.svg';

import '../../../modals/MeetingNotesModal/styles.scss';
import classes from '../../../modals/MeetingNotesModal/styles.module.scss';

const htmlToDraftBlocks = (html) => {
  const blocksFromHtml = htmlToDraft(html || '');
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
  return EditorState.createWithContent(contentState);
};

const toolbar = {
  options: ['history', 'fontSize', 'inline', 'textAlign', 'list', 'link'],
  fontSize: { dropdownClassName: classes.fontSizeDropdown },
  inline: {
    options: ['bold', 'italic'],
    bold: { icon: boldIcon, className: classes.toolbarIcon },
    italic: { icon: italicIcon, className: classes.toolbarIcon },
  },
  list: {
    inDropdown: true,
    options: ['unordered', 'ordered'],
    unordered: { icon: unorderedIcon, className: classes.toolbarIcon },
    ordered: { icon: orderedIcon, className: classes.toolbarIcon },
  },
  textAlign: {
    inDropdown: true,
    options: ['left', 'center'],
    left: { icon: leftIcon, className: classNames(classes.toolbarIcon, classes.left) },
    center: { icon: centerIcon, className: classes.toolbarIcon },
  },
  history: {
    undo: { icon: undoIcon, className: classes.toolbarIcon },
    redo: { icon: redoIcon, className: classes.toolbarIcon },
  },
  link: {
    options: ['link'],
    defaultTargetOption: '_blank',
    link: { icon: linkIcon, className: classes.toolbarIcon },
  },
};

export default function TextEditorModal({ show, initialHtml, onSave, onClose }) {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

  useEffect(() => {
    if (show) {
      if (initialHtml) setEditorState(htmlToDraftBlocks(initialHtml));
      else setEditorState(EditorState.createEmpty());
    }
  }, [show, initialHtml]);

  const handleSave = () => {
    const raw = convertToRaw(editorState.getCurrentContent());
    const markup = draftToHtml(raw);
    onSave(markup);
  };

  return (
    <Modal show={show} centered contentClassName={classes.MeetingNotesModal} dialogClassName={classes.dialog} backdropClassName={classes.backdrop}>
      <header className={classes.header}>
        <i className={classes.closeIcon} onClick={onClose}>Close</i>
        <h1>Add Text</h1>
      </header>
      <div className={classes.editorContainer}>
        <div className={classes.label}>Insert Text</div>
        <Editor
          editorState={editorState}
          wrapperClassName={classes.editorWrapper}
          editorClassName={classes.editor}
          onEditorStateChange={setEditorState}
          toolbar={toolbar}
          placeholder="Start Typing ...."
          stripPastedStyles
          spellCheck
        />
      </div>
      <footer className={classes.footer}>
        <div className={classes.buttons}>
          <button className={classes.saveButton} type="button" onClick={handleSave}>
            <img src={checkmarkIcon} alt="Save" />
          </button>
        </div>
      </footer>
    </Modal>
  );
}

